import { isArtifactCanvasFirstPaintProjection } from 'flare-chat-core/contracts/canvas/artifactCanvasAdmissibility';
import { selectBoundArtifactProjection } from './artifactBindingProjection.js';
import { normalizeAnalysisArtifactPayload } from './canvasAnalysisPayloadNormalizer.js';

/** Only the immutable row selected by the canonical analysis tab supplies live content. */
export function selectCanvasAnalysisPayload({ sessionContext } = {}) {
  const bound = selectBoundArtifactProjection(sessionContext ?? {}, 'analysis');
  if (!bound) return null;
  const payload = normalizeAnalysisArtifactPayload(bound.artifact_document.latest_revision);
  if (!payload) return null;
  return { ...payload, artifact_id: bound.artifact_ref.artifact_id, artifact_ref: bound.artifact_ref,
    document: bound.artifact_document, document_presentation: bound.artifact_document.document_presentation };
}

/** First paint is an explicit backend presentation contract, never a loading inference. */
export function selectCanvasAnalysisPending({ sessionContext } = {}) {
  const context = sessionContext ?? {};
  const canvasState = context.canvas_state;
  return !selectBoundArtifactProjection(context, 'analysis')
    && canvasState?.ui_signal?.active_tab === 'analysis'
    && isArtifactCanvasFirstPaintProjection(canvasState);
}

export default selectCanvasAnalysisPayload;
